export default __webpack_public_path__ + "static/Domovea_01-afce8cb5c0013b67d87058601dfb3afa.webp";